import { inject } from '@angular/core';
import { ApiServerService } from '../../core/api';
import { Coupon } from './coupon.models';

const baseUrl = 'coupons';

export const injectCouponApi = () => {
  const service = inject(ApiServerService);
  return {
    /** Verifica si un cupón es válido para el usuario, email y monto de carrito dados. */
    verify: (data: CouponVerifyRequest = null): Promise<CouponVerifyResponse> => {
      const path = `${baseUrl}/verify`;
      return service.call<CouponVerifyResponse, CouponVerifyRequest>(path, data);
    },

    /** Obtiene estadísticas de uso de un cupón (usos mes actual y anterior). */
    getUsageStats: (request: CouponUsageStatsRequest): Promise<CouponUsageStatsResponse> => {
      const path = `${baseUrl}/getUsageStats/${request.couponCode}`;
      return service.call<CouponUsageStatsResponse>(path);
    }
  };
};

export interface CouponVerifyRequest {
  code: string;
  userId?: string;
  email?: string;
  cartAmount: number;
}

export interface CouponVerifyResponse extends Partial<Omit<Coupon, 'id' | 'description' | 'promo'>> {
  valid: boolean; // Obligatorio en la respuesta
  label?: string; // Campo extra para i18n o UI feedback
}

export interface CouponUsageStatsResponse {
  uses?: {
    currentMonth?: number;
    previousMonth?: number;
  };
}

export interface CouponUsageStatsRequest {
  couponCode: string;
}

